import { Row } from 'antd';
import { config } from 'config/config';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { PlatformEnum } from 'src/shared/enums';

const OutOfService: FC = () => {
  const { formatMessage } = useIntl();
  const iframeStyles = { width: '100%', minHeight: '99vh', border: 'none' };
  let iframeSrc: string | null = null;

  switch (config.APP.PLATFORM) {
    case PlatformEnum.CON_SPAIN:
    case PlatformEnum.CON_MEXICO:
    case PlatformEnum.CON_CHILE:
    case PlatformEnum.CON_COLOMBIA:
      iframeSrc =
        'https://assets.landings.isdin.com/landings/LT-212-landing-mantenimiento-mx/_/v3/index.html';
      break;
    case PlatformEnum.CON_PORTUGAL:
      iframeSrc =
        'https://assets.landings.isdin.com/landings/LT-475-landing-mantenimiento-pt/_/v1/index.html';
      break;
    default:
      iframeSrc = null;
  }

  if (iframeSrc) {
    return <iframe style={iframeStyles} src={iframeSrc} />;
  }

  return (
    <Row>
      <div className="out-of-service">
        <div className="out-of-service__container">
          <div className="out-of-service__content">
            <svg
              className="svg-inline--fa fa-exclamation-triangle fa-w-18"
              aria-hidden="true"
              focusable="false"
              data-prefix="fas"
              data-icon="exclamation-triangle"
              role="img"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              data-fa-i2svg="">
              <path
                fill="currentColor"
                d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path>
            </svg>

            <p>{formatMessage({ id: 'app.out-of-service' })}</p>
          </div>
        </div>
      </div>
    </Row>
  );
};

export default OutOfService;
